import { money } from "@/lib/api";

/**
 * Live room budget health: approved solid, awaiting-approval lighter, against the budget.
 */
export default function RoomBudgetBar({ budget = 0, approved = 0, pending = 0, compact, testId }) {
  const total = Number(budget) || 0;
  const app = Number(approved) || 0;
  const pen = Number(pending) || 0;
  const projected = app + pen;
  const remaining = Math.round((total - projected) * 100) / 100;
  const over = total > 0 && projected > total;
  const scale = Math.max(total, projected) || 1;
  const appPct = Math.min(100, (app / scale) * 100);
  const penPct = Math.min(100 - appPct, (pen / scale) * 100);
  const budgetPct = total > 0 ? Math.min(100, (total / scale) * 100) : 100;

  return (
    <div data-testid={testId} className="w-full">
      <div className="relative h-[6px] w-full overflow-hidden bg-line">
        <div className="absolute inset-y-0 left-0 bg-lime transition-[width] duration-500" style={{ width: `${appPct}%` }} />
        <div className="absolute inset-y-0 bg-[#DDE3C8] transition-[width] duration-500" style={{ left: `${appPct}%`, width: `${penPct}%` }} />
        {total > 0 && budgetPct < 100 && (
          <div className="absolute inset-y-0 w-[2px] bg-ink" style={{ left: `${budgetPct}%` }} title="Budget" />
        )}
      </div>
      {!compact && (
        <div className="mt-3 space-y-1.5 text-xs">
          <div className="flex justify-between gap-3">
            <span className="text-stone">Budget</span>
            <span className="num text-ink">{money(total)}</span>
          </div>
          <div className="flex justify-between gap-3">
            <span className="text-stone">Approved</span>
            <span className="num text-lime-dark">{money(app)}</span>
          </div>
          {pen > 0 && (
            <div className="flex justify-between gap-3">
              <span className="text-stone">Awaiting approval</span>
              <span className="num text-stone">{money(pen)}</span>
            </div>
          )}
          <div className="flex justify-between gap-3 border-t border-line pt-1.5">
            <span className="text-ink">{over ? "Projected over budget by" : "Remaining"}</span>
            <span className={`num ${over ? "text-clay" : "text-ink"}`}>{money(Math.abs(remaining))}</span>
          </div>
        </div>
      )}
      {!compact && (
        <p className="mt-2 text-[11px] leading-relaxed text-fog">
          {total === 0
            ? "No budget set for this room yet."
            : over
            ? "Everything currently proposed would take this room past its budget."
            : pen > 0
            ? "Includes the selections still waiting on approval."
            : "Comfortably on track."}
        </p>
      )}
    </div>
  );
}
